import videoAsset from "@/assets/featured-flooring.mp4.asset.json";

const FeaturedProject = () => (
  <section className="relative bg-muted/40 section-padding" aria-labelledby="featured-project-title">
    <div className="container-max grid items-center gap-10 md:grid-cols-2 lg:gap-16">
      <div className="overflow-hidden rounded-2xl border border-border/70 bg-card shadow-premium">
        <video
          src={`${videoAsset.url}#t=0.1`}
          controls
          playsInline
          preload="metadata"
          className="aspect-[9/16] max-h-[640px] w-full bg-accent object-contain"
          aria-label="Vinyl flooring replacement project video"
        />
      </div>
      <div className="text-center md:text-left">
        <span className="eyebrow-pill">Featured Project</span>
        <h2
          id="featured-project-title"
          className="mt-5 text-3xl font-bold leading-tight text-foreground md:text-4xl lg:text-5xl"
        >
          New flooring transforms your space! ✨
        </h2>
        <p className="mt-5 text-lg leading-relaxed text-muted-foreground">
          We replaced the moisture-damaged vinyl flooring, leaving a brand-new floor with beautiful
          finishes and careful attention to detail.
        </p>
        <p className="mt-6 border-l-4 border-primary pl-4 text-left text-base font-semibold italic text-primary">
          At Villalobos Prime Services, we put care and dedication into every renovation. Contact us
          and bring new life to your home!
        </p>
      </div>
    </div>
  </section>
);

export default FeaturedProject;
